import type { IDropdownItemTypeButtonProps } from './DropdownItemTypeButton'

import { styled } from '@linaria/react'
import { AvatarStyled } from 'atoms/Avatar'
import { ButtonSC } from 'atoms/Button'
import { IconSC } from 'atoms/Icon'
import { TextBoxSC } from 'atoms/TextBox'
import { COLOR, FIXED_INDENTS, FONTS, MEDIA } from 'vars/index'
import { DropdownItemColumnGap } from '../DropdownItem.h'

export const DropdownItemProfileSC = styled.div<
  Pick<IDropdownItemTypeButtonProps, 'font' | 'selected'>
>`
  display: grid;
  grid-template-columns: max-content 1fr max-content max-content;
  align-items: center;
  gap: var(${FIXED_INDENTS.INDENT_30});
  width: 100%;
  height: 100%;

  ${TextBoxSC} {
    font: ${({ font }) => `var(${font})`};
  }

  ${AvatarStyled} {
    ${TextBoxSC} {
      line-height: var(${FIXED_INDENTS.INDENT_40});
      font: var(${FONTS.FontXsBold});
    }
  }
`

export const DropdownItemTypeButtonStyled = styled.div<
  IDropdownItemTypeButtonProps & { selected: boolean }
>`
  display: flex;
  align-items: center;
  width: ${({ width }) => width || 'auto'};
  height: ${({ height }) => (height ? `${height}%` : 'auto')};
  padding: ${({ paddings }) =>
    paddings && paddings.length > 0
      ? paddings.map((item) => `var(${item})`)?.join(' ')
      : 0};
  column-gap: ${({ columnGap }) =>
    `var(${columnGap || DropdownItemColumnGap.INDENT_0})`};
  background-color: ${({
    selected,
    backgroundSelectedDefault,
    backgroundDefault,
    backgroundDisabledDefault,
    disabled,
  }) =>
    disabled
      ? `var(${backgroundDisabledDefault})`
      : selected
        ? `var(${backgroundSelectedDefault})`
        : `var(${backgroundDefault})`};
  font: ${({ font }) => `var(${font})`};
  box-sizing: border-box;
  border: none;
  outline: none;

  ${IconSC} {
    color: ${({
      selected,
      disabled,
      colorDefault,
      iconColorSelected,
      colorDisabled,
    }) =>
      disabled
        ? `var(${colorDisabled})`
        : selected
          ? `var(${iconColorSelected})`
          : `var(${colorDefault})`};
    margin-right: var(${FIXED_INDENTS.INDENT_40});
  }

  ${TextBoxSC} {
    color: ${({
      selected,
      disabled,
      colorDefault,
      colorSelected,
      colorDisabled,
    }) =>
      disabled
        ? `var(${colorDisabled})`
        : selected
          ? `var(${colorSelected})`
          : `var(${colorDefault})`};
  }

  ${AvatarStyled} {
    ${TextBoxSC} {
      color: var(${COLOR.TEXT_ICON_PRIMARY});
    }
  }

  ${MEDIA.NO_TOUCH} {
    &:hover {
      background-color: ${({ backgroundHovered }) =>
        `var(${backgroundHovered})`};
      cursor: pointer;

      ${TextBoxSC} {
        color: ${({ selected, colorSelected, colorHovered }) =>
          selected ? `var(${colorSelected})` : `var(${colorHovered})`};
      }

      ${AvatarStyled} {
        ${TextBoxSC} {
          color: var(${COLOR.TEXT_ICON_PRIMARY});
        }
      }
    }
  }

  ${DropdownItemProfileSC} {
    ${ButtonSC} {
      &:last-child {
        visibility: ${({ selected }) => (selected ? 'hidden' : 'visible')};
      }
    }
  }

  &:active {
    background-color: ${({ backgroundPressed }) => `var(${backgroundPressed})`};

    ${TextBoxSC} {
      color: ${({ selected, colorSelected, colorPressed }) =>
        selected ? `var(${colorSelected})` : `var(${colorPressed})`};
    }
  }

  & svg:last-child {
    margin-right: 0;
    margin-left: auto;
  }

  ${MEDIA.NO_TOUCH} {
    ${DropdownItemProfileSC} {
      ${ButtonSC} {
        display: none;
      }
    }
    &:hover {
      ${ButtonSC} {
        display: inline-flex;
      }
    }
  }
`
